import { ChatCircle, Heart, SealCheck, Sparkle, Star, UserCircle } from "@phosphor-icons/react";
import { Face } from "@/lib/brand";
import { GlassIcon } from "@/components/site/SiteBits";
import GlassDemo from "@/components/site/GlassDemo";

// HTML/CSS replicas of the app screens (illustrations, not live data). Colors follow the site theme.
export function Phone({ children, tilt = "", className = "", testId = "phone" }) {
  return (
    <div className={`s-phone ${tilt} ${className}`} data-testid={testId} aria-hidden>
      <div className="s-phone-screen"><div className="s-phone-notch" />{children}</div>
    </div>
  );
}

const Status = () => <div className="flex h-10 items-end justify-between px-6 pb-1 text-[11px] font-semibold"><span>9:41</span><span className="tracking-widest">•••</span></div>;
const Title = ({ children }) => <p className="px-5 pb-3 pt-2 text-[20px] font-bold tracking-tight">{children}</p>;
// Same tabs, glyphs and fill rule as the app (mobile app/(tabs)/_layout.tsx): fill when active, regular otherwise.
const TABS = [["Discover", Sparkle], ["Crushes", Heart], ["Chat", ChatCircle], ["Profile", UserCircle]];
function TabBar({ active = 0 }) {
  return (
    <div className="absolute inset-x-0 bottom-0 bg-[var(--s-screen)] px-3 pb-3.5 pt-1">
      <div className="s-tabbar">
        {TABS.map(([label, I], i) => (
          <div key={label} className={`s-tab ${i === active ? "is-on" : ""}`}>
            <I size={17} weight={i === active ? "fill" : "regular"} /><span>{label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
const Photo = ({ className = "" }) => <div className={`relative overflow-hidden bg-[linear-gradient(160deg,#F6C2A8_0%,#E98A6B_45%,#9C3E28_100%)] ${className}`}><div className="absolute -bottom-6 left-1/2 h-40 w-32 -translate-x-1/2 rounded-t-full bg-black/15" /><div className="absolute bottom-28 left-1/2 h-16 w-16 -translate-x-1/2 rounded-full bg-black/15" /></div>;
const Badge = ({ icon: I, children }) => <span className="inline-flex items-center gap-1 rounded-full bg-white/90 px-2 py-0.5 text-[10px] font-semibold text-[#1C1412]"><I size={11} weight="fill" className="text-[var(--s-coral)]" />{children}</span>;
const Faces = () => <div className="flex justify-center gap-5"><span className="rounded-full bg-[var(--s-screen)] p-2 shadow-lg"><Face name="blink" className="h-9 w-9" /></span><span className="rounded-full bg-[var(--s-screen)] p-2 shadow-lg"><Face name="crush" className="h-9 w-9" /></span></div>;
const Avatar = ({ i, n }) => <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-[13px] font-bold text-white ${["bg-[#E2553A]", "bg-[#B5623F]", "bg-[#7A4A3C]", "bg-[#D98B5F]"][i % 4]}`}>{n[0]}</span>;

export function DiscoverScreen() {
  return (
    <>
      <Status /><Title>Discover</Title>
      <div className="relative mx-4 overflow-hidden rounded-[22px]">
        <Photo className="h-[330px]" />
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-4 pt-16 text-white">
          <p className="text-[19px] font-bold">Maya, 29</p>
          <p className="text-[11px] opacity-85">Milwaukee · 3 mi</p>
          <div className="mt-2 flex gap-1.5"><Badge icon={SealCheck}>Verified</Badge><Badge icon={Star}>Founding Crush</Badge></div>
        </div>
      </div>
      <div className="-mt-6 relative"><Faces /></div>
      <TabBar active={0} />
    </>
  );
}

const CRUSHES = [["Jordan", "Crushed on you"], ["Sam", "Super Crush"], ["Alex", "Crushed on you"]];
export function CrushesScreen() {
  return (
    <>
      <Status /><Title>Your crushes</Title>
      <ul className="space-y-2 px-4">
        {CRUSHES.map(([n, l], i) => (
          <li key={n} className="s-screen-card flex items-center gap-3 p-3">
            <Avatar i={i} n={n} /><span className="min-w-0 flex-1"><b className="block text-[13px]">{n}</b><span className="s-screen-muted block truncate text-[11px]">{l}</span></span>
            <span className="rounded-full bg-[var(--s-grad)] px-3 py-1 text-[11px] font-semibold text-white" style={{ background: "var(--s-grad)" }}>Wink</span>
          </li>
        ))}
        <li className="flex items-center gap-3 rounded-[14px] border border-dashed border-[var(--s-coral-2)] p-3 text-[12px] font-medium text-[var(--s-coral-2)]"><GlassIcon size={20} />Breaking glass is free here</li>
      </ul>
      <TabBar active={1} />
    </>
  );
}

const CHATS = [["Jordan", "See you Saturday?", "2m"], ["Sam", "Haha, same. Tacos then?", "1h"], ["Alex", "That trail looks amazing", "Tue"]];
export function ChatsScreen() {
  return (
    <>
      <Status /><Title>Your chats</Title>
      <div className="mx-4 flex items-center gap-3 rounded-[14px] p-3 text-white" style={{ background: "var(--s-grad)" }}>
        <Face name="wink" className="h-10 w-10 rounded-full bg-white p-1" /><span><b className="block text-[13px]">Maya winked</b><span className="block text-[11px] opacity-90">Say the first hi</span></span>
      </div>
      <ul className="mt-2 px-2">
        {CHATS.map(([n, m, t], i) => (
          <li key={n} className="flex items-center gap-3 border-b border-[var(--s-line)] px-2 py-3">
            <Avatar i={i} n={n} /><span className="min-w-0 flex-1"><b className="block text-[13px]">{n}</b><span className="s-screen-muted block truncate text-[11px]">{m}</span></span><span className="s-screen-muted text-[10px]">{t}</span>
          </li>
        ))}
      </ul>
      <TabBar active={2} />
    </>
  );
}

export function ProfileScreen({ copy }) {
  return (
    <>
      <Status />
      <div className="px-4">
        <div className="relative overflow-hidden rounded-[20px]"><Photo className="h-[128px]" />
          <div className="absolute bottom-3 left-3 flex items-center gap-2 text-white"><b className="text-[17px]">Maya, 29</b><Badge icon={SealCheck}>Verified</Badge></div></div>
        <div className="s-screen-card mt-3 p-3"><p className="s-screen-muted text-[9px] font-bold tracking-[0.12em]">LOOKING FOR</p><p className="mt-0.5 text-[13px] font-semibold">Serious relationship</p></div>
        <div className="mt-3"><GlassDemo copy={copy} /></div>
        <div className="s-screen-card mt-3 p-3"><p className="s-screen-muted text-[11px]">The way to my heart is…</p><p className="mt-0.5 text-[14px] font-semibold">Tacos and a good playlist.</p></div>
        <div className="mt-3"><Faces /></div>
      </div>
      <TabBar active={0} />
    </>
  );
}
